import { HIDE_MODAL, SHOW_MODAL } from './actions';

export type ModalState = {
  current?: string;
};

export type ModalActions = {
  type: 'HIDE_MODAL' | 'SHOW_MODAL';
  modal?: string;
};

const initialState: ModalState = {
  current: undefined,
};

export default (state = initialState, action: ModalActions) => {
  if (!state) {
    return {
      current: undefined,
    };
  }
  switch (action.type) {
    case HIDE_MODAL:
    case SHOW_MODAL: {
      const { modal } = action;
      return {
        ...state,
        current: modal || undefined,
      };
    }
    default:
      break;
  }
  return state;
};
